import { memo, useRef, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { Box, Flex, useToast } from '@chakra-ui/react'
import { updateDsr, resetUpdateDsrOutcome } from '../../digital-sales-room/actions/dsr-actions';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import { hasQuillTextContent, triggerLaunchdeckToast } from '../../global/helpers/global-helpers'
import LaunchdeckInputTextArea from '../../forms/TextareaField/components/LaunchdeckInputTextArea'
import LaunchdeckDisplayTextArea from '../../forms/TextareaField/components/LaunchdeckDisplayTextArea'
import { displayReactIcon } from '../helpers/dsr-display-helpers'


function DsrTeamNotesPage({
  // Parent component
  dsrId,
  dsrProperties,
  // Redux actions
  updateDsr,
  resetUpdateDsrOutcome,
  // Redux state
  isMobileView,
  updateDsrOutcome
}) {


  const toast = useToast();
  const [editMode, setEditMode] = useState(false)
  const [latestDsrProperties, setLatestDsrProperties] = useState(dsrProperties)

  const { dsrUserNotes } = latestDsrProperties || {};
  const { noteContent } = dsrUserNotes || {}

  const defaultScrollViewRef = useRef(false);

  useEffect(() => {
    if (defaultScrollViewRef.current && !isMobileView) {
      const elementPosition = defaultScrollViewRef.current.getBoundingClientRect().top;
      const offset = 200; // Offset (200px)

      window.scrollTo({
        top: elementPosition - offset, // Scroll to the position minus the offset
        // behavior: 'smooth',
      });
    }
  }, []);

  useEffect(() => {
    if (updateDsrOutcome) {
      const { updateDsrStatus, updatedDsrId, sourceEvent } = updateDsrOutcome || {};
      if (sourceEvent === "save-room-properties") {
        if (updateDsrStatus && updatedDsrId === dsrId && dsrId !== undefined) {
          toast(
            triggerLaunchdeckToast({
              useCase: "show-success-state",
              label: "Team notes successfully updated",
              isMobileView
            })
          )

        } else if (!updateDsrStatus) {
          toast(
            triggerLaunchdeckToast({
              useCase: "show-error-state",
              label: "Unfortunately something went wrong. Please try again later.",
              isMobileView
            })
          )

        }

        resetUpdateDsrOutcome()
      }
    }
  }, [updateDsrOutcome, toast, dsrId, resetUpdateDsrOutcome]);

  const onChangeHandler = (targetName, content) => {
    switch (targetName) {
      case ('dsrNotes'): {
        if (content) {
          setLatestDsrProperties({
            ...latestDsrProperties,
            dsrUserNotes: {
              ...dsrUserNotes,
              noteContent: content,
              noteEditedAt: new Date() 
            }
          })
        }
        break;
      }
      default: {
        break;
      }
    }
  };

  const handleSaveDsrProperties = () => {
    if (dsrId) {
      updateDsr({
        dsrId: dsrId,
        dsrProperties: latestDsrProperties,
        sourceEvent: "save-room-properties"
      })
    }

    setEditMode(false)
  }

  const discardEdits = () => {
    dsrProperties && setLatestDsrProperties(dsrProperties)
    setEditMode(false)
  }
  
  return (
    <Box>
      <Flex justify='space-between' align='center'>
        <Box ref={defaultScrollViewRef}>
          <Box color='brandDark.500' fontSize={['1.2em', '1.2em', '1.5em', '1.5em']} lineHeight='1.4em' fontWeight='600'>Team Notes</Box>
          <Box color='brandDark.500' fontSize={['0.75em', '0.75em', '0.875em', '0.875em']} fontWeight='400'>
            Private team notes to coordinate with fellow Host admins & members
          </Box>
        </Box>
      </Flex>

      {editMode ?
        <Box w='100%' mt='2em' >
          <Box mb='0.5em'>
            <Flex className='fade-in' p='0.3em 0em' rounded='0.5em' justify='flex-start' align='center' fontSize='0.75em' color='brandDark.500' gap={4}>{displayReactIcon('edit')} Editing</Flex>
          </Box>
          
          <LaunchdeckInputTextArea
            name={'dsrNotes'}
            onChangeHandler={onChangeHandler}
            defaultDelta={noteContent}
            placeholder={"Share internal notes with your team here"}
            backgroundColor='white'
            showBorder
            borderColor='#5aabf1' // Brand.500 color
          />

          <Flex w='100%' justify='flex-end' mt='2em' gap='0.5em'>
            <LaunchdeckButton bg='gray.300' color='gray.700' onClick={() => discardEdits()} label='Cancel' />
            <LaunchdeckButton bg='brand.500' color='white' onClick={() => handleSaveDsrProperties()} label='Save' />
          </Flex>
        </Box>
        :
        <Box w='100%' mt='2em'>
          {hasQuillTextContent(noteContent) ?
          <> 
            <LaunchdeckDisplayTextArea deltaContent={noteContent} cursor='default' placeholder={"Share team notes here"}/>

            <Flex w='100%' justify='flex-end' mt='2em'>
              <LaunchdeckButton bg='brandDark.500' color='white' onClick={() => setEditMode(true)} label='Edit' />
            </Flex>
          </>
          :
<>
   <Flex w='100%' justify='flex-start' mt='2em'>
              <LaunchdeckButton bg='brand.500' color='white' onClick={() => setEditMode(true)} label='Create notes' />
            </Flex>
</>
}
        </Box>
      }
    </Box>

  )

}

const mapStateToProps = (state) => {
  return {
    updateDsrOutcome: state.updateDsrOutcome.results.data,
    isMobileView: state.mobileViewMode.isMobileView
  }
}


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDsr,
      resetUpdateDsrOutcome
    },
    dispatch,
  )

export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrTeamNotesPage)))
